import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../config/URL";
import { toast } from "react-toastify";

function TermsConditions() {
  const [content, setContent] = useState("");
  const id = 2;

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      try {
        const response = await api.get(`/getAllTermsAndConditionSavePublish`);
        if (response.status === 200) {
          setContent(response.data[0]?.termsConditionContent || "");
        }
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
            "Failed to fetch terms and conditions"
        );
      }
    };

    fetchTermsAndConditions();
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  return (
    <section style={{ backgroundColor: "#f9fafb" }}>
      <div
        className="container py-5"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </section>
  );
}

export default TermsConditions;
